// Wer darf welchen Bereich der Einstellungen sehen?
// Regel hängt ausschließlich an der Rolle - niemals an einzelnen Personen.
export const FULL_ACCESS_ROLES = ['admin', 'geschaeftsfuehrung'];

export const SETTINGS_TABS = [
  { value: 'verwaltung',    label: 'Verwaltung',    fullAccessOnly: true },
  { value: 'email',         label: 'E-Mail',        fullAccessOnly: true },
  { value: 'organisation',  label: 'Organisation',  fullAccessOnly: true },
  { value: 'schulferien',   label: 'Schulferien',   fullAccessOnly: false },
  { value: 'integrationen', label: 'Integrationen', fullAccessOnly: true },
  { value: 'ki',            label: 'KI',            fullAccessOnly: true },
  { value: 'system',        label: 'System',        fullAccessOnly: true },
];

export const hasFullSettingsAccess = (role) => FULL_ACCESS_ROLES.includes(role);

export const getVisibleSettingsTabs = (role) =>
  SETTINGS_TABS.filter((t) => hasFullSettingsAccess(role) || !t.fullAccessOnly);

export const canSeeSettingsTab = (role, value) =>
  getVisibleSettingsTabs(role).some((t) => t.value === value);
